import { Button } from "@/components/ui/button";

interface Props {
  error: Error;
  resetError: () => void;
}

const SentryErrorFallback = ({ error, resetError }: Props) => (
  <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background p-6 text-center">
    <h1 className="text-2xl font-bold text-destructive">Something went wrong</h1>
    <p className="max-w-md text-muted-foreground">
      An unexpected error occurred. Our team has been notified.
    </p>
    <pre className="max-w-lg overflow-auto rounded bg-muted p-3 text-xs text-muted-foreground">
      {error.message}
    </pre>
    <Button onClick={resetError}>Try again</Button>
  </div>
);

export default SentryErrorFallback;
